import React, { useState, useEffect, useRef } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Upload, Trash, Calendar3 } from 'react-bootstrap-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Country, CountryState, CustomerDetails } from "../../../types";

import axiosInstance from "../../../services/axios.instance";
import { API_URL, baseUrl } from "../../../services/apiConfig";
import { trackEvent } from "../../../services/events";
import { useNavigate } from "react-router-dom";
import "../../LocationStatus/styles.css";
import "./styles.css";
import {
  edit_icon_profile,
  kirkos_merchant_profile,
  manage_my_info_edit_logo,
  manage_my_profile_gen_info_icon,
  manage_my_profile_incomplete_logo,
  manage_my_profile_license_logo,
  manage_my_profile_location_logo,
  manage_my_profile_tick,
  pdf,
} from "../../../assets/images";
import CustomInput from "../../CustomInput";
import { useForm } from "react-hook-form";
import ImagePopupModal from "../../MerchantDashboard/ImagePopupModal";
import { toast } from "react-toastify";
import { useDropzone } from "react-dropzone";
import SuccessModal from "../../SuccessModal";
import NonInsSuccessModal from "../../NonInsSuccessModal";
import ContactAddressMapModal from "./ContactAddressMapModal";
import { SUCCESS_MESSAGES, ERROR_MESSAGES } from "../../../utils/messages";
import rules from "../../../rules";

const ManageMyProfile = () => {
  const [email, setEmailAddress] = useState<string>("");
  const [firstName, setfirstName] = useState<string>("");
  const [lastName, setlastName] = useState<string>("");
  const [license, setLicense] = useState<string>("");
  const [emiratesId, setEmiratesId] = useState<string>("");
  // const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [country, setCountry] = useState<string>("");
  const [selectedCountryId, setSelectedCountryId] = useState<string>("");
  const [stateData, setStateData] = useState<CountryState[]>([]);
  const [state1, setState1] = useState<string>("");
  const [imageSource, setImageSource] = useState("");
  const [showImagePopupModal, setShowImagePopupModal] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [licenseImage, setLicenseImage] = useState("");
  const [emiratesImage, setEmiratesImage] = useState("");
  const [visaImage, setVisaImage] = useState("");
  const [passportImage, setPassportImage] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const accessToken = localStorage.getItem("access_token");

  const openFileInput = (documentType: string) => {
    setSelectedDocumentType(documentType);
    fileInputRef?.current?.click();
  };

  const [profileImage, setProfileImage] = useState<string>("");
  const [uploadedImageUrl, setUploadedImageUrl] = useState<string>("");
  const [newImage, setNewImage] = useState<string>("");

  // const handleimagepopover = () => {
  //   setShowImagePopupModal(true);
  // };
  const [address, setAddress] = useState<string>("");
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [customerLocation, setCustomerLocation] = useState<{ latitude: number | null; longitude: number | null }>({ latitude: null, longitude: null });

  // Identity Verification States
  const [selectedOption1, setSelectedOption1] = useState<string>("UAE Residents");
  const [licenseFile, setLicenseFile] = useState<string[]>([]);
  const [emiratesIdFile, setEmiratesIdFile] = useState<string[]>([]);
  const [licenseFile2, setLicenseFile2] = useState<string[]>([]);
  const [PassportFile, setPassportFile] = useState<string[]>([]);
  const [VisitVisaFile, setVisitVisaFile] = useState<string[]>([]);
  const [expiryDate, setExpiryDate] = useState<any>(null);
  const [touristExpiryDate, setTouristExpiryDate] = useState<any>(null);
  const [expiryError, setExpiryError] = useState("");
  const [touristExpiryError, setTouristExpiryError] = useState("");
  const [licenseFileError, setLicenseFileError] = useState("");
  const [emiratesIdFileError, setEmiratesIdFileError] = useState("");
  const [licenseFile2Error, setLicenseFile2Error] = useState("");
  const [visitVisaFileError, setVisitVisaFileError] = useState("");
  const [passportFileError, setPassportFileError] = useState("");
  const [isLicenseLoading, setIsLicenseLoading] = useState(false);
  const docsErrorSectionRef = useRef<HTMLDivElement | null>(null);

  // Identity Verification Handlers
  const handleExpiryDateChange = (date: any) => setExpiryDate(date);
  const handleTouristExpiryDateChange = (date: any) => setTouristExpiryDate(date);
  const handleDeleteImageLicense = (index: number) => setLicenseFile(prev => prev.filter((_, i) => i !== index));
  const handleDeleteImageEmiratesId = (index: number) => setEmiratesIdFile(prev => prev.filter((_, i) => i !== index));
  const handleDeleteImageLicense2 = (index: number) => setLicenseFile2(prev => prev.filter((_, i) => i !== index));
  const handleDeleteImageVisitVisa = (index: number) => setVisitVisaFile(prev => prev.filter((_, i) => i !== index));
  const handleDeleteImagePassport = (index: number) => setPassportFile(prev => prev.filter((_, i) => i !== index));

  const { mutate: uploadMutate } = useMutation({
    mutationFn: async (files: FileList) => {
      const fd = new FormData();
      for (let i = 0; i < files.length; i++) { fd.append("document", files[i]); }
      const res = await axiosInstance.post(API_URL.DOC_UPLOAD, fd, { headers: { "Content-Type": "multipart/form-data" } });
      setUploadedFile((prev) => [...prev, res.data.uuid]);
      return res.data;
    }
  });

  const handleFileChangeLicense = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setLicenseFile([file.name]);
      const dt = new DataTransfer(); dt.items.add(file);
      uploadMutate(dt.files);
    }
  };

  const handleGenericFileChange = (e: React.ChangeEvent<HTMLInputElement>, setter: React.Dispatch<React.SetStateAction<string[]>>) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      setter(prev => [...prev, ...files.map(f => f.name)]);
      const dt = new DataTransfer(); files.forEach(f => dt.items.add(f));
      uploadMutate(dt.files);
    }
  };

  const renderCustomHeader = ({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }: any) => (
    <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
      <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>{"<"}</button>
      <select value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(Number(value))}>
        {Array.from({ length: 50 }, (_, i) => new Date().getFullYear() + i).map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
      <select value={date.getMonth()} onChange={({ target: { value } }) => changeMonth(Number(value))}>
        {["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].map((opt, i) => (
          <option key={opt} value={i}>{opt}</option>
        ))}
      </select>
      <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>{">"}</button>
    </div>
  );

  const handleLocationSelect = (selectedLocation: { name: string; latitude: number; longitude: number }) => {
    setCustomerLocation({ latitude: selectedLocation.latitude, longitude: selectedLocation.longitude });
    setValue("contactAddress", selectedLocation.name);
    setAddress(selectedLocation.name);
  };

  const { control, setValue, getValues, formState: { errors }, trigger } = useForm({ mode: "onChange" });

  const { data: countriesData } = useQuery<Country[], Error>({
    queryKey: ["countries"],
    queryFn: async () => {
      const response = await axiosInstance.get(API_URL.COUNTRY);
      return response.data;
    },
  });

  const handleDeleteAccount = async () => {
    const decodeToken = (token: any) => {
      if (token) {
        return JSON.parse(atob(token.split(".")[1]));
      } else {
        return null;
      }
    };

    const decodedToken = decodeToken(accessToken);
    const customerId =
      decodedToken && decodedToken["customer-id"]
        ? decodedToken["customer-id"]
        : null;
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/${API_URL.CUSTOMER_ACCOUNT_DELETE}/${customerId}`,
        {}
      );
      // console.log(response, "testing delete")
      toast.success(SUCCESS_MESSAGES.ACCOUNT_DELETED);
      localStorage.clear();
      navigate("/");
    } catch (error) {
      console.log(error)
      toast.error(ERROR_MESSAGES.ACCOUNT_DELETE_FAILED);
      setShowDeleteModal(false);
    }
  };
  const handleUpdate = () => {
    const formValues = getValues();

    // Validate all mandatory fields
    if (!formValues.firstname || !formValues.firstname.trim()) {
      toast.error(ERROR_MESSAGES.MANDATORY_FIELDS);
      return;
    }

    if (!formValues.lastname || !formValues.lastname.trim()) {
      toast.error("Please fill all the mandatory fields");
      return;
    }

    if (!formValues.emailaddress || !formValues.emailaddress.trim()) {
      toast.error("Please fill all the mandatory fields");
      return;
    }

    if (!formValues.contactAddress || !formValues.contactAddress.trim()) {
      toast.error("Please fill all the mandatory fields");
      return;
    }

    if (!country || !country.trim()) {
      toast.error("Please fill all the mandatory fields");
      return;
    }

    if (!state1 || !state1.trim()) {
      toast.error("Please fill all the mandatory fields");
      return;
    }

    if (customerData?.customerDocs?.LICENSE && !formValues.licensenumber) {
      toast.error(ERROR_MESSAGES.MANDATORY_FIELDS);
      return;
    }

    if (customerData?.customerDocs?.LICENSE && formValues.licensenumber) {
      const licensePattern = /^[A-Za-z0-9]{1,10}$/;
      if (!licensePattern.test(formValues.licensenumber)) {
        toast.error("Invalid License Number format");
        trigger("licensenumber");
        return;
      }
    }

    if (customerData?.customerDocs?.EMIRITIES && !formValues.emiratesidnumber) {
      toast.error("Please fill all the mandatory fields");
      return;
    }

    if (customerData?.customerDocs?.EMIRITIES && formValues.emiratesidnumber) {
      const emiratesPattern = /^784-\d{4}-\d{7}-\d{1}$/;
      if (!emiratesPattern.test(formValues.emiratesidnumber)) {
        toast.error("Invalid Emirates ID format (Eg: 784-1980-1234567-8)");
        trigger("emiratesidnumber");
        return;
      }
    }

    if (!isInfoAvailable && !isImageAvailable) {
      if (!selectedOption1) {
        toast.error("Please select either UAE Residents or Tourists option.");
        if (docsErrorSectionRef.current) docsErrorSectionRef.current.scrollIntoView({ behavior: "smooth" });
        return;
      }

      let isCustomValid = true;

      if (selectedOption1 === "UAE Residents") {
        if (!expiryDate || expiryError) {
          setExpiryError(expiryError || "Expiry Date is required");
          isCustomValid = false;
        }
        if (licenseFile.length === 0) {
          setLicenseFileError("License copy is required");
          isCustomValid = false;
        }
        if (emiratesIdFile.length === 0) {
          setEmiratesIdFileError("Emirates ID copy is required");
          isCustomValid = false;
        }
      } else if (selectedOption1 === "Tourists") {
        if (!touristExpiryDate || touristExpiryError) {
          setTouristExpiryError(touristExpiryError || "Expiry Date is required");
          isCustomValid = false;
        }
        if (licenseFile2.length === 0) {
          setLicenseFile2Error("License copy is required");
          isCustomValid = false;
        }
        if (VisitVisaFile.length === 0) {
          setVisitVisaFileError("Visit Visa copy is required");
          isCustomValid = false;
        }
        if (PassportFile.length === 0) {
          setPassportFileError("Passport copy is required");
          isCustomValid = false;
        }
      }

      if (!isCustomValid) {
        toast.error("Please provide all required documents");
        return;
      }
    }

    let customerDocs: { docId: string; docType: string; }[] = [];

    if (customerData?.customerDocs) {
      if (licenseImage) {
        customerDocs.push({
          docId: licenseImage,
          docType: "LICENSE",
        });
      }

      if (emiratesImage) {
        customerDocs.push({
          docId: emiratesImage,
          docType: "EMIRITIES",
        });
      }

      if (visaImage) {
        customerDocs.push({
          docId: visaImage,
          docType: "VisitVisa",
        });
      }

      if (passportImage) {
        customerDocs.push({
          docId: passportImage,
          docType: "Passport",
        });
      }
    }
    // let customerDocs = [];

    // if (customerData?.customerDocs) {
    //   customerDocs.push({
    //     docId: licenseImage,
    //     docType: "LICENSE",
    //     docName: "LICENCE NAME",
    //   });
    // }

    // if (customerData?.customerDocs) {
    //   customerDocs.push({
    //     docId: emiratesImage,
    //     docType: "EMIRITIES",
    //     docName: "EMIRITIES NAME",
    //   });
    // }

    // if (customerData?.customerDocs) {
    //   if (visaImage) {
    //     customerDocs.push({
    //       docId: visaImage,
    //       docType: "VisitVisa",
    //       docName: "VISITING VISA",
    //     });
    //   }
    // }

    // if (customerData?.customerDocs) {
    //   customerDocs.push({
    //     docId: passportImage,
    //     docType: "Passport",
    //     docName: "PASSPORT",
    //   });
    // }

    customerDocs = customerDocs.filter((doc) => doc.docId !== null);

    // If user has uploaded new identity documents from the profile form, merge them in
    if (!isInfoAvailable && !isImageAvailable && uploadedFile.length > 0) {
      let uuidIndex = 0;
      licenseFile.forEach((_, i) => {
        if (uploadedFile[uuidIndex]) customerDocs.push({ docId: uploadedFile[uuidIndex++], docType: i === 0 ? "LICENSE" : `LICENSE${i}` });
      });
      emiratesIdFile.forEach((_, i) => {
        if (uploadedFile[uuidIndex]) customerDocs.push({ docId: uploadedFile[uuidIndex++], docType: i === 0 ? "EMIRITIES" : `EMIRITIES${i}` });
      });
      licenseFile2.forEach((_, i) => {
        if (uploadedFile[uuidIndex]) customerDocs.push({ docId: uploadedFile[uuidIndex++], docType: i === 0 ? "LICENSE" : `LICENSE${i}` });
      });
      PassportFile.forEach((_, i) => {
        if (uploadedFile[uuidIndex]) customerDocs.push({ docId: uploadedFile[uuidIndex++], docType: i === 0 ? "Passport" : `Passport${i}` });
      });
      VisitVisaFile.forEach((_, i) => {
        if (uploadedFile[uuidIndex]) customerDocs.push({ docId: uploadedFile[uuidIndex++], docType: i === 0 ? "VisitVisa" : `VisitVisa${i}` });
      });

      // Use the licence number and emiratesId from the new identity form fields
      if (!formValues.licensenumber) {
        formValues.licensenumber = formValues.residentsLicenseNumber || formValues.touristsLicenseNumber || "";
      }
      if (!formValues.emiratesidnumber) {
        formValues.emiratesidnumber = formValues.residentsEmiratesIdNumber || "";
      }
    }

    let body = {
      notification: true,
      offer: false,
      language: "en",
      firstname: formValues.firstname,
      lastname: formValues.lastname,
      email: formValues.emailaddress,
      confirmEmail: "",
      licence: formValues.licensenumber || formValues.residentsLicenseNumber || formValues.touristsLicenseNumber || "",
      emiratesId: formValues.emiratesidnumber || formValues.residentsEmiratesIdNumber || "",
      customer_address: {
        address_1: formValues.contactAddress || "",
        street: "",
        city: "",
        district: "",
        state: formValues.state1 || state1,
        country: formValues.country || country,
        pin_code: "",
        latitude: customerLocation.latitude ? String(customerLocation.latitude) : "",
        longitude: customerLocation.longitude ? String(customerLocation.longitude) : "",
        location_info: formValues.contactAddress || "",
        address_type: "HOME"
      },
      customerDocs: customerDocs.length > 0 ? customerDocs : [],
      profilePicture: uploadedImageUrl || profileImage,
    };

    mutate(body);
  };

  const { mutate } = useMutation({
    mutationFn: (userData: any) =>
      axiosInstance.put(`${API_URL.PROFILE}`, userData),

    onSuccess: async (successResponse) => {
      await trackEvent({
        event_name: { web: "Kirkos_ProfileUpdate", app: "Kirkos_ProfileUpdate_App" },
        event_category: "Profile_Info",
        module: "Profile",
        payload: {
          status: "success",
          message: successResponse?.data?.message ?? "",
        },
      });
      // console.log("successResponseOtp", successResponse);
      if (successResponse.status && successResponse?.data?.message) {
        // Invalidate navbar's customer details query so it refetches updated profile
        queryClient.invalidateQueries({ queryKey: ["details"] });
        setShowSuccessModal(true);
      }
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        console.log("error", error);
      }
    },
  });

  useEffect(() => {
    const trackPageLoad = async () => {
      await trackEvent({
        event_name: { web: "Kirkos_ProfileScreen", app: "Kirkos_ProfileScreen_App" },
        event_category: "Profile_Info",
        module: "Profile",
        payload: {},
      });
    };
    trackPageLoad();
  }, []);

  const handleCountryChange = async (e: any) => {
    const selectedCountryName = e.target.value;
    setCountry(selectedCountryName);

    const selectedCountry = countriesData?.find(
      (country) => country.countryName === selectedCountryName
    );

    if (selectedCountry) {
      setSelectedCountryId(selectedCountry.countryId.toString());

      const response = await axiosInstance.get(
        `${API_URL.STATE}${selectedCountry.countryId}`
      );
      setStateData(response.data);
    }
  };

  const {
    data: customerData,
    isLoading,
    // isError,
    // error,
  } = useQuery<CustomerDetails, Error>({
    queryKey: ["detail"],
    queryFn: async () => {
      const response = await axiosInstance.get(API_URL.CUSTOMER_DETAILS);

      return response.data;
    },
  });

  useEffect(() => {
    const licenseId = customerData?.customerDocs?.LICENSE || customerData?.customerDocs?.LICENSE1;
    if (licenseId) {
      axiosInstance
        .get(`${API_URL.CUSTOMER_DOCUMENTS}/${licenseId}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          // console.log("Response:", response);
          if (response && response.data) {
            // console.log("dattatatattatatattata", response.data);
            const contentType = String(response.headers["content-type"] || "");
            const isPdf = contentType === "application/pdf";
            const isImage = contentType.startsWith("image/");
            // console.log("PDF ::: " + isPdf);
            if (isPdf) {
              const blob = new Blob([response.data], {
                type: "application/pdf",
              });
              const objectUrl = URL.createObjectURL(blob);
              const downloadLink = document.getElementById(
                "LICENSEDownloadLink"
              ) as HTMLAnchorElement;
              if (downloadLink) {
                downloadLink.href = objectUrl;
                downloadLink.style.display = "block";
                downloadLink.download = "LICENSE.pdf";
              }
              const LICENSE = document.getElementById("LICENSE");
              // LICENSE?.insertAdjacentText(
              //   "afterbegin",
              //   `Size: ${Number(response.data.byteLength) / 1000} KB`
              // );
              const imageElement = document.getElementById(
                "LICENSE_IMAGE"
              ) as HTMLImageElement;

              imageElement.src = pdf;
            } else if (isImage) {
              const blob = new Blob([response.data], { type: contentType });
              const imageUrl = URL.createObjectURL(blob);
              const imageElement = document.getElementById(
                "LICENSE_IMAGE"
              ) as HTMLImageElement;

              if (imageElement) {
                imageElement.src = imageUrl;
                imageElement.onclick = () => {
                  setImageSource(imageUrl);
                  setShowImagePopupModal(true);
                };
              }

              const imageSizeKB = response.data.byteLength / 1000;
              // console.log("Image Size:", imageSizeKB, "KB");
            }
          } else {
            console.error("Response or data is undefined");
          }
        });
    }
  }, [customerData]);
  useEffect(() => {
    const passportId = customerData?.customerDocs?.Passport || customerData?.customerDocs?.Passport1;
    if (passportId) {
      axiosInstance
        .get(`${API_URL.CUSTOMER_DOCUMENTS}/${passportId}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          // console.log("Response:", response);
          if (response && response.data) {
            // console.log("dattatatattatatattata", response.data);
            const contentType = String(response.headers["content-type"] || "");
            const isPdf = contentType === "application/pdf";
            const isImage = contentType.startsWith("image/");
            // console.log("PDF ::: " + isPdf);
            if (isPdf) {
              const blob = new Blob([response.data], {
                type: "application/pdf",
              });
              const objectUrl = URL.createObjectURL(blob);
              const downloadLink = document.getElementById(
                "PassportDownloadLink"
              ) as HTMLAnchorElement;
              if (downloadLink) {
                downloadLink.href = objectUrl;
                downloadLink.style.display = "block";
                downloadLink.download = "Passport.pdf";
              }
              const Passport = document.getElementById("LICENSE");
              // LICENSE?.insertAdjacentText(
              //   "afterbegin",
              //   `Size: ${Number(response.data.byteLength) / 1000} KB`
              // );
              const imageElement = document.getElementById(
                "PASSPORT_IMAGE"
              ) as HTMLImageElement;

              imageElement.src = pdf;
            } else if (isImage) {
              const blob = new Blob([response.data], { type: contentType });
              const imageUrl = URL.createObjectURL(blob);
              const imageElement = document.getElementById(
                "PASSPORT_IMAGE"
              ) as HTMLImageElement;

              if (imageElement) {
                imageElement.src = imageUrl;
                imageElement.onclick = () => {
                  setImageSource(imageUrl);
                  setShowImagePopupModal(true);
                };
              }

              const imageSizeKB = response.data.byteLength / 1000;
              // console.log("Image Size:", imageSizeKB, "KB");
            }
          } else {
            console.error("Response or data is undefined");
          }
        });
    }
  }, [customerData]);
  useEffect(() => {
    if (customerData) {
      setProfileImage(customerData?.customer_details?.profile_picture);
      setEmiratesImage(customerData?.customerDocs?.EMIRITIES);
      setLicenseImage(customerData?.customerDocs?.LICENSE);
      setPassportImage(customerData?.customerDocs?.Passport);
      setVisaImage(customerData?.customerDocs?.VisitngVisa);
    }
  }, [customerData]);
  const handleFilePreview = (file: File) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target) {
        const previewImage = e.target.result as string;
        let imageElement: HTMLImageElement | null = null;

        if (selectedDocumentType == "license") {
          imageElement = document.getElementById(
            "LICENSE_IMAGE"
          ) as HTMLImageElement | null;
        } else if (selectedDocumentType == "emirates") {
          imageElement = document.getElementById(
            "EMIRITIES_IMAGE"
          ) as HTMLImageElement | null;
        } else if (selectedDocumentType == "visa") {
          imageElement = document.getElementById(
            "VISA_IMAGE"
          ) as HTMLImageElement | null;
        } else if (selectedDocumentType == "passport") {
          imageElement = document.getElementById(
            "PASSPORT_IMAGE"
          ) as HTMLImageElement | null;
        }

        if (imageElement) {
          imageElement.src = previewImage;
        }
      }
    };
    reader.readAsDataURL(file);
  };
  const handleEmiratesPreview = (file: File) => {
    // Modify the function signature to accept a File object
    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target) {
        const previewImage = e.target.result as string;
        const emiratesImage = document.getElementById(
          "EMIRITIES_IMAGE"
        ) as HTMLImageElement | null;
        if (emiratesImage) {
          // Update the src attribute based on the presence of a preview image
          emiratesImage.src = previewImage;
        }
      }
    };
    reader.readAsDataURL(file);
  };
  useEffect(() => {
    const visitVisaId = customerData?.customerDocs?.VisitVisa || customerData?.customerDocs?.VisitVisa1 || customerData?.customerDocs?.VisitngVisa;
    if (visitVisaId) {
      axiosInstance
        .get(`${API_URL.CUSTOMER_DOCUMENTS}/${visitVisaId}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          // console.log("Response:", response);
          if (response && response.data) {
            // console.log("dattatatattatatattata", response.data);
            const contentType = String(response.headers["content-type"] || "");
            const isPdf = contentType === "application/pdf";
            const isImage = contentType.startsWith("image/");
            // console.log("PDF ::: " + isPdf);
            if (isPdf) {
              const blob = new Blob([response.data], {
                type: "application/pdf",
              });
              const objectUrl = URL.createObjectURL(blob);
              const downloadLink = document.getElementById(
                "VisitingVisaDownloadLink"
              ) as HTMLAnchorElement;
              if (downloadLink) {
                downloadLink.href = objectUrl;
                downloadLink.style.display = "block";
                downloadLink.download = "VisitVisa.pdf";
              }
              const EMIRITIES = document.getElementById("VisitVisa");
              // LICENSE?.insertAdjacentText(
              //   "afterbegin",
              //   `Size: ${Number(response.data.byteLength) / 1000} KB`
              // );
              const imageElement = document.getElementById(
                "VISA_IMAGE"
              ) as HTMLImageElement;
              // imageElement.src = imageUrl;

              imageElement.src = pdf;
            } else if (isImage) {
              const blob = new Blob([response.data], { type: contentType });
              const imageUrl = URL.createObjectURL(blob);
              const imageElement = document.getElementById(
                "VISA_IMAGE"
              ) as HTMLImageElement;
              // imageElement.src = imageUrl;

              if (imageElement) {
                imageElement.src = imageUrl;
                imageElement.onclick = () => {
                  setImageSource(imageUrl);
                  setShowImagePopupModal(true);
                };
              }

              const imageSizeKB = response.data.byteLength / 1000;
              // console.log("Image Size:", imageSizeKB, "KB");
            }
          } else {
            console.error("Response or data is undefined");
          }
        });
    }
  }, [customerData]);
  useEffect(() => {
    const emiratesId = customerData?.customerDocs?.EMIRITIES || customerData?.customerDocs?.EMIRITIES1;
    if (emiratesId) {
      axiosInstance
        .get(`${API_URL.CUSTOMER_DOCUMENTS}/${emiratesId}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          // console.log("Response:", response);
          if (response && response.data) {
            // console.log("dattatatattatatattata", response.data);
            const contentType = String(response.headers["content-type"] || "");
            const isPdf = contentType === "application/pdf";
            const isImage = contentType.startsWith("image/");
            // console.log("PDF ::: " + isPdf);
            if (isPdf) {
              const blob = new Blob([response.data], {
                type: "application/pdf",
              });
              const objectUrl = URL.createObjectURL(blob);
              const downloadLink = document.getElementById(
                "EMIRITIESDownloadLink"
              ) as HTMLAnchorElement;
              if (downloadLink) {
                downloadLink.href = objectUrl;
                downloadLink.style.display = "block";
                downloadLink.download = "EMIRITIES.pdf";
              }
              const EMIRITIES = document.getElementById("EMIRITIES");
              // LICENSE?.insertAdjacentText(
              //   "afterbegin",
              //   `Size: ${Number(response.data.byteLength) / 1000} KB`
              // );
              const imageElement = document.getElementById(
                "EMIRITIES_IMAGE"
              ) as HTMLImageElement;
              // imageElement.src = imageUrl;

              imageElement.src = pdf;
            } else if (isImage) {
              const blob = new Blob([response.data], { type: contentType });
              const imageUrl = URL.createObjectURL(blob);
              const imageElement = document.getElementById(
                "EMIRITIES_IMAGE"
              ) as HTMLImageElement;
              // imageElement.src = imageUrl;
              if (imageElement) {
                imageElement.src = imageUrl;
                imageElement.onclick = () => {
                  setImageSource(imageUrl);
                  setShowImagePopupModal(true);
                };
              }

              const imageSizeKB = response.data.byteLength / 1000;
              // console.log("Image Size:", imageSizeKB, "KB");
            }
          } else {
            console.error("Response or data is undefined");
          }
        });
    }
  }, [customerData]);

  useEffect(() => {
    if (!isLoading && customerData) {
      const { customer_details, kyc_and_bank_details, customerDocs } =
        customerData || {};
      const { firstName, lastName, phone_no, email, customer_address } =
        customer_details || {};

      const { licence_number, emirates_id } = kyc_and_bank_details || {};


      const address = customer_address?.location_info || customer_address?.address_1 || "";
      const state = customer_address?.state || "";
      const country = customer_address?.country || "";

      setValue("contactAddress", address);
      setAddress(address);
      setValue("firstname", firstName);
      setValue("lastname", lastName);
      setValue("phonenumber", phone_no);
      setValue("emailaddress", email);
      setCountry(String(country));
      const selectedCountry = countriesData?.find(
        (item) => String(item.countryName) === String(country)
      );

      if (selectedCountry) {
        setSelectedCountryId(selectedCountry.countryId.toString());

        axiosInstance
          .get(`${API_URL.STATE}${selectedCountry.countryId}`)
          .then((response) => {
            setStateData(response.data);
            setState1(String(state));
          })
          .catch((error) => {
            console.error("Error fetching state data:", error);
          });
      } else {
        setState1(String(state));
      }
      setValue("licensenumber", licence_number);
      setValue("emiratesidnumber", emirates_id);

      if (customer_address?.latitude && customer_address?.longitude) {
        setCustomerLocation({
          latitude: Number(customer_address.latitude),
          longitude: Number(customer_address.longitude),
        });
      }
    }
  }, [isLoading, customerData, countriesData]);

  const isInfoAvailable =
    customerData?.kyc_and_bank_details.emirates_id &&
    (customerData?.customerDocs?.LICENSE || customerData?.customerDocs?.LICENSE1);

  const docs = customerData?.customerDocs;
  const hasLicense = docs?.LICENSE || docs?.LICENSE1;

  const isImageAvailable =
    (hasLicense && docs?.VisitVisa && docs?.Passport) ||
    (hasLicense && docs?.EMIRITIES);

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const formData = new FormData();
      formData.append("product_image", file);

      try {
        const response = await axiosInstance.post(
          API_URL.PRODUCT_IMAGE_UPLOAD,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        // console.log("Image uploaded successfully:", response);

        if (response.data) {
          setNewImage(response.data);
          setUploadedImageUrl(response.data);
          // console.log(uploadedImageUrl, "profffff");
        }
      } catch (error) {
        // Handle error
        console.error("Error uploading image:", error);
      }
    }
  };

  const triggerFileInput = () => {
    const fileInput = document.getElementById("profileImageInput");
    if (fileInput) {
      (fileInput as HTMLInputElement).click();
    }
  };
  const [selectedImage, setSelectedImage] = useState<string[]>([]);
  const [uploadedFile, setUploadedFile] = useState<string[]>([]);

  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const handleFileChange = async (files: File[], documentType: string) => {
    // console.log("enteredd here---");
    const updatedImages = [...selectedImage];
    files.forEach((file) => {
      updatedImages.push(file.name);
    });

    setSelectedImage(updatedImages);
    let isSuccess = true; //
    for (const file of files) {
      const formData = new FormData();
      formData.append("document", file);

      try {
        const response = await axiosInstance.post(
          API_URL.DOC_UPLOAD,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const imageUrl = response.data.uuid;
        // console.log("url--->", imageUrl);

        if (documentType == "license") {
          setLicenseImage(imageUrl);
          handleFilePreview(file);
        } else if (documentType == "emirates") {
          setEmiratesImage(imageUrl);
          handleFilePreview(file);
        } else if (documentType == "visa") {
          setVisaImage(imageUrl);
          handleFilePreview(file);
        } else if (documentType == "passport") {
          setPassportImage(imageUrl);
          handleFilePreview(file);
        }

        setUploadedFile((prevUploadedFiles) => [
          ...prevUploadedFiles,
          imageUrl,
        ]);
      } catch (error) {
        console.error("Error uploading image", error);
        isSuccess = false;
      }
    }
    // Handle success/error toast messages based on isSuccess
  };

  // const handleDocChange = async (acceptedFiles: File[]) => {
  //   console.log("enteredd here---");
  //   const updatedImages = [...selectedImage];
  //   acceptedFiles.forEach((file) => {
  //     updatedImages.push(file.name);
  //   });

  //   setSelectedImage(updatedImages);
  //   let isSuccess = true; //
  //   for (const file of acceptedFiles) {
  //     const formData = new FormData();
  //     formData.append("document", file);

  //     try {
  //       const response = await axiosInstance.post(
  //         API_URL.DOC_UPLOAD,
  //         formData,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data",
  //           },
  //         }
  //       );

  //       const imageUrl = response.data.uuid;
  //       console.log("url--->", imageUrl);

  //       setEmiratesImage(imageUrl);
  //       handleEmiratesPreview(file);
  //       setUploadedFile((prevUploadedFiles) => [
  //         ...prevUploadedFiles,
  //         imageUrl,
  //       ]);
  //     } catch (error) {
  //       console.error("Error uploading image", error);
  //       isSuccess = false;
  //     }
  //   }
  //   if (isSuccess) {
  //     setIsSuccess(true);
  //     toast.success("Documents Uploaded Successfully!", {
  //       position: "top-right",
  //     });
  //   } else {
  //     setIsSuccess(false);
  //     toast.error("Error uploading documents. Please try again.", {
  //       position: "top-right",
  //     });
  //   }
  // };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      // console.log("hereeeee---->", selectedDocumentType);

      // Separate license and emirates files based on their names

      if (acceptedFiles.length > 0) {
        // Handle emirates files
        handleFileChange(acceptedFiles, selectedDocumentType);
      }
      if (acceptedFiles.length === 0) {
        toast.error("Please upload only image files.", {
          position: "top-right",
        });
      }
    },
    accept: "image/*" as any,
  });

  // const {} = useDropzone({
  //   onDrop: (acceptedFiles) => {
  //     const imageFiles = acceptedFiles.filter((file) =>
  //       file.type.startsWith("image/")
  //     );
  //     if (imageFiles.length > 0) {
  //       handleDocChange(imageFiles);
  //     } else {
  //       toast.error("Please upload only image files.", {
  //         position: "top-right",
  //       });
  //     }
  //   },re
  //   accept: "image/*" as any,
  // });

  return (
    <div className="row ">
      <div className="col-md-12 pt-4  ">
        <div className="d-flex justify-content-between">
          <div className=" my_profile_top_text text-start">
            Manage your Details, View your status, Edit your details.
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 16,
            }}
          >
            <button
              className=" btn all_button_style text-black"
              onClick={() => setShowDeleteModal(true)}
            >
              Delete Account
            </button>
          </div>
        </div>

        {showDeleteModal && (
          <div
            className="modal show"
            style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content" style={{ borderRadius: 12 }}>
                <div className="modal-body" style={{ padding: 24 }}>
                  <p style={{ fontSize: 16, marginBottom: 0 }}>
                    Are you sure you want to delete this account?
                  </p>
                </div>
                <div
                  className="modal-footer justify-content-center"
                  style={{ justifyContent: "flex-end", gap: 8 }}
                >
                  <button
                    className="btn-lg w-25 cancel-button"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn-lg w-25 ok-button-modal "
                    style={{ height: "40px" }}
                    onClick={handleDeleteAccount}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="row pt-4">
          <div className="col-md-4  text-center">
            <div className="card my_profile_box">
              <div className="card-body align-content-center">
                <div className="col-md-12 pt-4">
                  <div className="d-flex justify-content-center">
                    <div className="profile-img-div">
                      <img
                        src={
                          newImage || profileImage || kirkos_merchant_profile
                        }
                        width="110"
                        className="img-profile"
                        alt="Profile"
                      />
                      <input
                        type="file"
                        id="profileImageInput"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleImageUpload}
                      />
                      <div className="plus-icon-div" onClick={triggerFileInput}>
                        {/* <PencilFill className="plus-style" /> */}
                        <div className="plus-style">
                          <img src={edit_icon_profile} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 my_profile_name pt-1">{`${customerData?.customer_details.firstName} ${customerData?.customer_details.lastName}`}</div>
                <div className="col-md-12 d-flex justify-content-center my_profile_box_one">
                  <div className="my_profile_number ">
                    {customerData?.customer_details.phone_no}
                  </div>
                  <div className="ps-2 ">
                    <img src={manage_my_profile_tick} width="16" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-8 my_profile_box_two text-start">
            <div className="card my_profile_box">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 d-flex">
                    <div className="pt-1">
                      <img src={manage_my_profile_gen_info_icon} width="23" />
                    </div>
                    <div className="my_profile_geninfo ps-2">
                      General Information
                    </div>
                  </div>
                  <div className="col-md-6 d-flex  justify-content-md-end">
                    <div className="my_profile_infoedit text-end">
                      Information Editable
                    </div>
                    <div className="ps-2">
                      <img src={manage_my_info_edit_logo} width="18" />
                    </div>
                  </div>
                </div>
                <div className="row pt-3">
                  <div className="col-md-6 pt-3">
                    <div className="my_profile_input_text-label ">
                      First Name <span className="merchantStar">*</span>
                    </div>
                    <CustomInput
                      inputName="firstname"
                      inputType="firstname"
                      className="my_profile_input_field pt-1"
                      placeholder="Alex"
                      editable={true}
                      showEditIcon={true}
                      onInputChange={(value: string) => setfirstName(value)}
                      control={control}
                    // rules={rules.AuthRules.bank_name}
                    />
                  </div>
                  <div className="col-md-6 pt-3">
                    <div className=" my_profile_input_text-label">
                      Last Name <span className="merchantStar">*</span>
                    </div>
                    <CustomInput
                      inputName="lastname"
                      inputType="lastname"
                      className="my_profile_input_field pt-1"
                      placeholder="John"
                      editable={true}
                      showEditIcon={true}
                      onInputChange={(value: string) => setlastName(value)}
                      control={control}
                    // rules={rules.AuthRules.bank_name}
                    />
                  </div>
                  <div className="col-md-12 pt-3">
                    <div className="my_profile_input_text-label">
                      Email <span className="merchantStar">*</span>
                    </div>
                    <CustomInput
                      inputName="emailaddress"
                      inputType="emailaddress"
                      className="my_profile_input_field pt-1"
                      placeholder="John"
                      editable={true}
                      showEditIcon={true}
                      onInputChange={(value: string) => setEmailAddress(value)}
                      control={control}
                      rules={rules.AuthRules.email}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="row ">
          <div className="col-md-12 text-start pt-5">
            <div className="card my_profile_box">
              <div className="card-body">
                <div className="row pb-3">
                  <div className="col-md-12 d-flex">
                    <div className="pt-1">
                      <img src={manage_my_profile_license_logo} width="23" />
                    </div>
                    <div className="my_profile_geninfo ps-2">
                      License Details / Documents
                    </div>
                    {!isInfoAvailable && !isImageAvailable && (
                      <div className="ps-4">
                        <div className="my_profile_license_box  d-flex">
                          <div className="ps-2 pt-1">
                            <img
                              src={manage_my_profile_incomplete_logo}
                              width="23"
                            />
                          </div>
                          <div className="my_profile_incomplete_text px-2">
                            Currently your Documents are incomplete
                            <br />
                            Please update the Documents
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row pt-4">
                  {customerData?.customerDocs?.LICENSE ? (
                    <>
                      <div className="col-md-3">
                        <div className="my_profile_input_text"></div>
                        <div className="pt-3">
                          <div className="my_profile_input_text-label">
                            License Number{" "}
                            <span className="merchantStar">*</span>
                          </div>
                          <CustomInput
                            inputName="licensenumber"
                            inputType="licensenumber"
                            className="my_profile_input_field pt-1"
                            placeholder="Enter your License Number"
                            editable={true}
                      showEditIcon={true}
                            onInputChange={(value: string) => setLicense(value)}
                            control={control}
                            // rules={rules.AuthRules.email}
                          />
                        </div>
                      </div>
                      <div className="col-md-3 pt-3">
                        {customerData?.customerDocs?.LICENSE ? (
                          <>
                            <div className="row">
                              <div
                                id="license_container"
                                className="col-md-6 mb-2"
                              >
                                <p className="my_profile_input_text-label">
                                  LICENSE:{" "}
                                </p>
                                <img
                                  id="LICENSE_IMAGE"
                                  style={{ width: 75, height: 75 }}
                                />
                                <p id="LICENSE"></p>
                                <a
                                  className="download-img"
                                  id="LICENSEDownloadLink"
                                  style={{ display: "none" }}
                                  title="Download LICENSE PDF"
                                >
                                  Download LICENSE PDF
                                </a>
                              </div>
                              <div className="pt-3">
                                <button
                                  onClick={() => openFileInput("license")}
                                  className="my_profile_upload_button text-center"
                                >
                                  Remove / Upload
                                </button>
                                <input
                                  {...getInputProps()}
                                  type="file"
                                  ref={fileInputRef}
                                  style={{ display: "none" }}
                                  multiple
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <button className="my_profile_upload_button text-center">
                            Upload
                          </button>
                        )}
                      </div>

                      <div className="col-md-3 pt-3">
                        <div className="">
                          <div className="my_profile_input_text-label">
                            Emirates ID Number{" "}
                            <span className="merchantStar">*</span>
                          </div>
                          <CustomInput
                            inputName="emiratesidnumber"
                            inputType="emiratesidnumber"
                            className="my_profile_input_field pt-1"
                            placeholder="Enter your ID Number"
                            editable={true}
                      showEditIcon={true}
                            onInputChange={(value: string) =>
                              setEmiratesId(value)
                            }
                            control={control}
                          />
                        </div>
                      </div>
                      <div className="col-md-3 pt-3">
                        {customerData?.kyc_and_bank_details ? (
                          <>
                            <div className="row">
                              {customerData?.customerDocs && (
                                <div
                                  id="emirites_container"
                                  className="col-md-6 mb-2"
                                >
                                  <p className="my_profile_input_text-label">
                                    EMIRATES:{" "}
                                  </p>
                                  <img
                                    id="EMIRITIES_IMAGE"
                                    style={{ width: 75, height: 75 }}
                                  />
                                  <p id="EMIRITIES"></p>
                                  <a
                                    className="download-img"
                                    id="EMIRITIESDownloadLink"
                                    title="Download EMIRITIES PDF"
                                    style={{ display: "none" }}
                                  >
                                    Download EMIRATES PDF
                                  </a>
                                </div>
                              )}
                            </div>
                            <div className="pt-3">
                              <button
                                onClick={() => openFileInput("emirates")}
                                className="my_profile_upload_button text-center"
                              >
                                Remove / Upload
                              </button>
                              <input
                                {...getInputProps()}
                                type="file"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                multiple
                              />
                            </div>
                          </>
                        ) : (
                          <button className="my_profile_upload_button text-center">
                            Remove / Upload
                          </button>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="row">
                      <div className="col-md-3 pt-3">
                        {customerData?.kyc_and_bank_details ? (
                          <>
                            <div className="row">
                              <div
                                id="license_container"
                                className="col-md-6 mb-2"
                              >
                                <p className="my_profile_input_text-label">
                                  VISITING VISA:{" "}
                                </p>
                                <img
                                  id="VISA_IMAGE"
                                  style={{ width: 75, height: 75 }}
                                />
                                <p id="VISA"></p>
                                <a
                                  className="download-img"
                                  id="LICENSEDownloadLink"
                                  style={{ display: "none" }}
                                  title="Download LICENSE PDF"
                                >
                                  Download VISA PDF
                                </a>
                              </div>
                              <div className="pt-3">
                                <button
                                  onClick={() => openFileInput("visa")}
                                  className="my_profile_upload_button text-center"
                                >
                                  Remove / Upload
                                </button>
                                <input
                                  {...getInputProps()}
                                  type="file"
                                  ref={fileInputRef}
                                  style={{ display: "none" }}
                                  multiple
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <button className="my_profile_upload_button text-center">
                            Upload
                          </button>
                        )}
                      </div>
                      <div className="col-md-3 pt-3">
                        {customerData?.kyc_and_bank_details ? (
                          <>
                            <div className="row">
                              {customerData?.customerDocs && (
                                <div
                                  id="emirites_container"
                                  className="col-md-6 mb-2"
                                >
                                  <p className="my_profile_input_text-label">
                                    Passport:{" "}
                                  </p>
                                  <img
                                    id="PASSPORT_IMAGE"
                                    style={{ width: 75, height: 75 }}
                                  />
                                  <p id="EMIRITIES"></p>
                                  <a
                                    className="download-img"
                                    id="EMIRITIESDownloadLink"
                                    title="Download EMIRITIES PDF"
                                    style={{ display: "none" }}
                                  >
                                    Download PASSPORT PDF
                                  </a>
                                </div>
                              )}
                            </div>
                            <div className="pt-3">
                              <button
                                onClick={() => openFileInput("passport")}
                                className="my_profile_upload_button text-center"
                              >
                                Remove / Upload
                              </button>
                              <input
                                {...getInputProps()}
                                type="file"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                multiple
                              />
                            </div>
                          </>
                        ) : (
                          <button className="my_profile_upload_button text-center">
                            Remove / Upload
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="row ">
          <div className="col-md-12 text-start pt-5">
            <div className="card my_profile_box">
              <div className="card-body">
                <div className="row pb-3">
                  <div className="col-md-12 d-flex">
                    <div className="pt-1">
                      <img src={manage_my_profile_license_logo} width="23" />
                    </div>
                    <div className="my_profile_geninfo ps-2">
                      License Details / Documents
                    </div>
                    {!isInfoAvailable && !isImageAvailable && (
                      <div className="ps-4 w-100">
                        <div className="my_profile_license_box d-flex mb-2">
                          <div className="ps-2 pt-1">
                            <img src={manage_my_profile_incomplete_logo} width="23" />
                          </div>
                          <div className="my_profile_incomplete_text px-2">
                            Currently your Documents are incomplete
                            <br />
                            Please upload them below
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Identity Verification Upload Form - shown when no docs yet */}
                {!isInfoAvailable && !isImageAvailable && (
                  <div className="row pt-4">
                    <div className="col-md-12">
                      <div className="doc-selection-tabs">
                        <label className={`doc-tab d-flex align-items-center justify-content-start gap-2 ${selectedOption1 === "UAE Residents" ? 'active' : ''}`}>
                          <input
                            type="radio"
                            name="identityType"
                            value="UAE Residents"
                            checked={selectedOption1 === "UAE Residents"}
                            onChange={() => setSelectedOption1("UAE Residents")}
                            className="custom-radio-input"
                          />
                          <span className="radio-custom"></span>
                          UAE Resident
                        </label>
                        <label className={`doc-tab d-flex align-items-center justify-content-start gap-2 ${selectedOption1 === "Tourists" ? 'active' : ''}`}>
                          <input
                            type="radio"
                            name="identityType"
                            value="Tourists"
                            checked={selectedOption1 === "Tourists"}
                            onChange={() => setSelectedOption1("Tourists")}
                            className="custom-radio-input"
                          />
                          <span className="radio-custom"></span>
                          Tourist
                        </label>
                      </div>
                    </div>

                    {selectedOption1 === "UAE Residents" && (
                      <>
                        <div className="col-md-6 mt-3">
                          <div className="res_license_num">Driving License (Copy) <span style={{ color: 'red' }}>*</span></div>
                          <div className="upload-field-container">
                            {isLicenseLoading ? <div className="spinner-border text-warning"></div> : (
                              <>
                                {licenseFile.length === 0 ? (
                                  <button className="btn-custom-upload" onClick={() => (document.getElementById('prof-lic-inp') as any).click()}><Upload /> Browse</button>
                                ) : (
                                  <div className="uploaded-files-list">
                                    {licenseFile.map((name, i) => (
                                      <div key={i} className="uploaded-file-item">
                                        <span className="file-name">{name}</span>
                                        <Trash className="delete-icon" onClick={() => handleDeleteImageLicense(i)} />
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </>
                            )}
                            <input id="prof-lic-inp" type="file" hidden accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onClick={(e) => { (e.target as HTMLInputElement).value = ''; }} onChange={handleFileChangeLicense} />
                            {licenseFileError && <div className="text-danger mt-1 small">{licenseFileError}</div>}
                          </div>
                        </div>
                        <div className="col-md-6 mt-3">
                          <div className="res_license_num">Emirates ID (Copy) <span style={{ color: 'red' }}>*</span></div>
                          <div className="upload-field-container">
                            {emiratesIdFile.length === 0 ? (
                              <button className="btn-custom-upload" onClick={() => (document.getElementById('prof-eid-inp') as any).click()}><Upload /> Browse</button>
                            ) : (
                              <div className="uploaded-files-list">
                                {emiratesIdFile.map((name, i) => (
                                  <div key={i} className="uploaded-file-item">
                                    <span className="file-name">{name}</span>
                                    <Trash className="delete-icon" onClick={() => handleDeleteImageEmiratesId(i)} />
                                  </div>
                                ))}
                              </div>
                            )}
                            <input id="prof-eid-inp" type="file" hidden accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onClick={(e) => { (e.target as HTMLInputElement).value = ''; }} onChange={(e) => handleGenericFileChange(e, setEmiratesIdFile)} multiple />
                            {emiratesIdFileError && <div className="text-danger mt-1 small">{emiratesIdFileError}</div>}
                          </div>
                        </div>
                        <div className="col-md-6 mt-3">
                          <div className="res_license_num">License Number</div>
                          <CustomInput
                            inputName="residentsLicenseNumber"
                            inputType="text"
                            className="my_profile_input_field pt-1"
                            placeholder="Eg: 123456"
                            control={control}
                            rules={rules.AuthRules.license_number}
                            onInputChange={(val: string) => { }}
                            editable={true}
                            showEditIcon={true}
                          />
                        </div>
                        <div className="col-md-6 mt-3">
                          <div className="res_license_num">Emirates ID Number</div>
                          <CustomInput
                            inputName="residentsEmiratesIdNumber"
                            inputType="text"
                            className="my_profile_input_field pt-1"
                            placeholder="784-19XX-XXXXXXX-X"
                            control={control}
                            rules={rules.AuthRules.emirates_id}
                            onInputChange={(val: string) => { }}
                            editable={true}
                            showEditIcon={true}
                          />
                        </div>
                        <div className="col-md-6 mt-3">
                          <div className="res_license_num">License Expiry Date <span style={{ color: 'red' }}>*</span></div>
                          <div className="date-line-noninsurence">
                            <Calendar3 className="calendar-icon-expiry" />
                            <DatePicker
                              selected={expiryDate ? new Date(expiryDate) : null}
                              onChange={handleExpiryDateChange}
                              dateFormat="EEE, MMM d, yyyy"
                              customInput={<input readOnly className="input-date" onFocus={(e) => e.target.blur()} />}
                              renderCustomHeader={renderCustomHeader}
                              popperClassName="license-expiry-datepicker"
                              popperPlacement="top-start"
                              portalId="root"
                              minDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                            />
                          </div>
                          {expiryError && <div className="text-danger small">{expiryError}</div>}
                        </div>
                      </>
                    )}

                    {selectedOption1 === "Tourists" && (
                      <>
                        <div className="col-md-6 mt-3">
                          <div className="res_license_num">License Copy <span style={{ color: 'red' }}>*</span></div>
                          <div className="upload-field-container">
                            {licenseFile2.length === 0 ? (
                              <button className="btn-custom-upload" onClick={() => (document.getElementById('prof-lic2-inp') as any).click()}><Upload /> Browse</button>
                            ) : (
                              <div className="uploaded-files-list">
                                {licenseFile2.map((name, i) => (
                                  <div key={i} className="uploaded-file-item">
                                    <span className="file-name">{name}</span>
                                    <Trash className="delete-icon" onClick={() => handleDeleteImageLicense2(i)} />
                                  </div>
                                ))}
                              </div>
                            )}
                            <input id="prof-lic2-inp" type="file" hidden accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onClick={(e) => { (e.target as HTMLInputElement).value = ''; }} onChange={(e) => handleGenericFileChange(e, setLicenseFile2)} multiple />
                            {licenseFile2Error && <div className="text-danger mt-1 small">{licenseFile2Error}</div>}
                          </div>
                        </div>
                        <div className="col-md-6 mt-3">
                          <div className="res_license_num">Passport Copy <span style={{ color: 'red' }}>*</span></div>
                          <div className="upload-field-container">
                            {PassportFile.length === 0 ? (
                              <button className="btn-custom-upload" onClick={() => (document.getElementById('prof-pass-inp') as any).click()}><Upload /> Browse</button>
                            ) : (
                              <div className="uploaded-files-list">
                                {PassportFile.map((name, i) => (
                                  <div key={i} className="uploaded-file-item">
                                    <span className="file-name">{name}</span>
                                    <Trash className="delete-icon" onClick={() => handleDeleteImagePassport(i)} />
                                  </div>
                                ))}
                              </div>
                            )}
                            <input id="prof-pass-inp" type="file" hidden accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onClick={(e) => { (e.target as HTMLInputElement).value = ''; }} onChange={(e) => handleGenericFileChange(e, setPassportFile)} multiple />
                            {passportFileError && <div className="text-danger mt-1 small">{passportFileError}</div>}
                          </div>
                        </div>
                        <div className="col-md-12 mt-3">
                          <div className="res_license_num">Visit Visa Copy <span style={{ color: 'red' }}>*</span></div>
                          <div className="upload-field-container">
                            {VisitVisaFile.length === 0 ? (
                              <button className="btn-custom-upload" onClick={() => (document.getElementById('prof-visa-inp') as any).click()}><Upload /> Browse</button>
                            ) : (
                              <div className="uploaded-files-list">
                                {VisitVisaFile.map((name, i) => (
                                  <div key={i} className="uploaded-file-item">
                                    <span className="file-name">{name}</span>
                                    <Trash className="delete-icon" onClick={() => handleDeleteImageVisitVisa(i)} />
                                  </div>
                                ))}
                              </div>
                            )}
                            <input id="prof-visa-inp" type="file" hidden accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onClick={(e) => { (e.target as HTMLInputElement).value = ''; }} onChange={(e) => handleGenericFileChange(e, setVisitVisaFile)} multiple />
                            {visitVisaFileError && <div className="text-danger mt-1 small">{visitVisaFileError}</div>}
                          </div>
                        </div>
                        <div className="col-md-6 mt-3">
                          <div className="res_license_num">License Number</div>
                          <CustomInput
                            inputName="touristsLicenseNumber"
                            inputType="text"
                            className="my_profile_input_field pt-1"
                            placeholder="Eg: 449236"
                            control={control}
                            onInputChange={(val: string) => { }}
                            editable={true}
                            showEditIcon={true}
                          />
                        </div>
                        <div className="col-md-6 mt-3">
                          <div className="res_license_num">License Expiry Date <span style={{ color: 'red' }}>*</span></div>
                          <div className="date-line-noninsurence">
                            <Calendar3 className="calendar-icon-expiry" />
                            <DatePicker
                              selected={touristExpiryDate ? new Date(touristExpiryDate) : null}
                              onChange={handleTouristExpiryDateChange}
                              dateFormat="EEE, MMM d, yyyy"
                              customInput={<input readOnly className="input-date" onFocus={(e) => e.target.blur()} />}
                              renderCustomHeader={renderCustomHeader}
                              popperClassName="license-expiry-datepicker"
                              popperPlacement="top-start"
                              portalId="root"
                              minDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                            />
                          </div>
                          {touristExpiryError && <div className="text-danger small">{touristExpiryError}</div>}
                        </div>
                      </>
                    )}
                  </div>
                )}

                <div className="row pt-4">
                  {hasLicense && (
                    <>
                      <div className="col-md-3">
                        <div className="my_profile_input_text"></div>
                        <div className="pt-3">
                          <div className="my_profile_input_text-label">
                            License Number{" "}
                            <span className="merchantStar">*</span>
                          </div>
                          <CustomInput
                            inputName="licensenumber"
                            inputType="licensenumber"
                            className="my_profile_input_field pt-1"
                            placeholder="Enter your License Number"
                            editable={true}
                            showEditIcon={true}
                            onInputChange={(value: string) =>
                              setLicense(value)
                            }
                            control={control}
                            rules={rules.AuthRules.license_number}
                          />
                        </div>
                      </div>
                      <div className="col-md-3 pt-3">
                        <div className="row">
                          <div
                            id="license_container"
                            className="col-md-6 mb-2"
                          >
                            <p className="my_profile_input_text-label">
                              LICENSE:{" "}
                            </p>
                            <img
                              id="LICENSE_IMAGE"
                              style={{ width: 75, height: 75 }}
                            />
                            <p id="LICENSE"></p>
                            <a
                              className="download-img"
                              id="LICENSEDownloadLink"
                              style={{ display: "none" }}
                              title="Download LICENSE PDF"
                            >
                              Download LICENSE PDF
                            </a>
                          </div>
                          <div className="pt-3">
                            <button
                              onClick={() => openFileInput("license")}
                              className="my_profile_upload_button text-center"
                            >
                              Remove / Upload
                            </button>
                            <input
                              {...getInputProps()}
                              type="file"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              multiple
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {customerData?.customerDocs?.EMIRITIES && (
                    <>
                      <div className="col-md-3">
                        <div className="my_profile_input_text"></div>
                        <div className="pt-3">
                          <div className="my_profile_input_text-label">
                            Emirates ID Number{" "}
                            <span className="merchantStar">*</span>
                          </div>
                          <CustomInput
                            inputName="emiratesidnumber"
                            inputType="emiratesidnumber"
                            className="my_profile_input_field pt-1"
                            placeholder="Enter your ID Number"
                            editable={true}
                            showEditIcon={true}
                            onInputChange={(value: string) =>
                              setEmiratesId(value)
                            }
                            control={control}
                            rules={rules.AuthRules.emirates_id}
                          />
                        </div>
                      </div>
                      <div className="col-md-3 pt-3">
                        <div className="row">
                          <div
                            id="emirites_container"
                            className="col-md-6 mb-2"
                          >
                            <p className="my_profile_input_text-label">
                              EMIRATES:{" "}
                            </p>
                            <img
                              id="EMIRITIES_IMAGE"
                              style={{ width: 75, height: 75 }}
                            />
                            <p id="EMIRITIES"></p>
                            <a
                              className="download-img"
                              id="EMIRITIESDownloadLink"
                              style={{ display: "none" }}
                              title="Download EMIRITIES PDF"
                            >
                              Download EMIRATES PDF
                            </a>
                          </div>
                          <div className="pt-3">
                            <button
                              onClick={() => openFileInput("emirates")}
                              className="my_profile_upload_button text-center"
                            >
                              Remove / Upload
                            </button>
                            <input
                              {...getInputProps()}
                              type="file"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              multiple
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {customerData?.customerDocs?.VisitVisa && (
                    <>
                      <div className="col-md-3 pt-3">
                        <div className="row">
                          <div
                            id="visitvisa_container"
                            className="col-md-6 mb-2"
                          >
                            <p className="my_profile_input_text-label">
                              Visit Visa:{" "}
                            </p>
                            <img
                              id="VISA_IMAGE"
                              style={{ width: 75, height: 75 }}
                            />
                            <p id="VISA"></p>
                            <a
                              className="download-img"
                              id="VISADownloadLink"
                              style={{ display: "none" }}
                              title="Download Visit Visa PDF"
                            >
                              Download Visit Visa PDF
                            </a>
                          </div>
                          <div className="pt-3">
                            <button
                              onClick={() => openFileInput("visitvisa")}
                              className="my_profile_upload_button text-center"
                            >
                              Remove / Upload
                            </button>
                            <input
                              {...getInputProps()}
                              type="file"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              multiple
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {customerData?.customerDocs?.Passport && (
                    <>
                      <div className="col-md-3 pt-3">
                        <div className="row">
                          <div
                            id="passport_container"
                            className="col-md-6 mb-2"
                          >
                            <p className="my_profile_input_text-label">
                              Passport:{" "}
                            </p>
                            <img
                              id="PASSPORT_IMAGE"
                              style={{ width: 75, height: 75 }}
                            />
                            <p id="PASSPORT"></p>
                            <a
                              className="download-img"
                              id="PASSPORTDownloadLink"
                              style={{ display: "none" }}
                              title="Download Passport PDF"
                            >
                              Download Passport PDF
                            </a>
                          </div>
                          <div className="pt-3">
                            <button
                              onClick={() => openFileInput("passport")}
                              className="my_profile_upload_button text-center"
                            >
                              Remove / Upload
                            </button>
                            <input
                              {...getInputProps()}
                              type="file"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              multiple
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Add other document sections here */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row ">
          <div className="col-md-12 text-start pt-5">
            <div className="card my_profile_box">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 d-flex">
                    <div className="pt-1">
                      <img src={manage_my_profile_location_logo} width="23" />
                    </div>
                    <div className="my_profile_geninfo ps-2">
                      Contact Address
                    </div>
                  </div>
                  <div className="col-md-6 d-flex  justify-content-md-end">
                    <div className="my_profile_infoedit text-end">
                      Information Editable
                    </div>
                    <div className="ps-2">
                      <img src={manage_my_info_edit_logo} width="18" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 pt-3">
                    <div className="my_profile_input_text-label">
                      Contact Address <span className="merchantStar">*</span>
                    </div>
                    <div onClick={() => setShowLocationModal(true)} style={{ cursor: "pointer", position: "relative" }}>
                      {/* Transparent overlay to safely capture clicks over the disabled input */}
                      <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 10 }} />
                      <CustomInput
                        inputName="contactAddress"
                        inputType="contactAddress"
                        className="my_profile_input_field pt-1"
                        placeholder="Select location from map"
                        editable={true}
                        showEditIcon={true}
                        onInputChange={(value: string) => setAddress(value)}
                        control={control}
                      // rules={rules.AuthRules.email}
                      />
                    </div>
                  </div>
                  <div className="col-md-4 pt-3">
                    <div className="my_profile_input_text-label">
                      Country <span className="merchantStar">*</span>
                    </div>
                    <select
                      className="my_profile_input_field pt-1"
                      value={country}
                      onChange={handleCountryChange}
                    >
                      <option
                        value=""
                        key="select"
                        className="business_page_right_side_font"
                      >
                        Select country
                      </option>
                      {countriesData &&
                        countriesData.map((country) => (
                          <option
                            key={country.countryId}
                            value={country.countryName}
                          >
                            {country.countryName}
                          </option>
                        ))}
                    </select>
                  </div>
                  {/* <div className="col-md-5 d-md-flex justify-content-md-end"> */}
                  <div className="col-md-4 pt-3">
                    <div className="my_profile_input_text-label">
                      State <span className="merchantStar">*</span>
                    </div>
                    <select
                      className="my_profile_input_field pt-1"
                      value={state1}
                      onChange={(e) => setState1(e.target.value)}
                    >
                      <option
                        value=""
                        key="select"
                        className="business_page_right_side_font"
                      >
                        Select state
                      </option>
                      {stateData &&
                        stateData.map((state) => (
                          <option key={state.id} value={state.state_name}>
                            {state.state_name}
                          </option>
                        ))}
                    </select>
                    {/* </div> */}
                  </div>
                </div>
                <div className="row float-end">
                  <div className="col-md-4 pt-5 pb-2">
                    <button
                      className=" btn all_button_style text-black"
                      onClick={handleUpdate}
                    >
                      UPDATE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <NonInsSuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        onNav={() => {
          navigate("/customer/myaccount");
          setShowSuccessModal(false);
        }}
        message={"Your profile details have been updated successfully."}
      />
      <ImagePopupModal
        isOpen={showImagePopupModal}
        //  onClose={onCloseImagePopupModal}
        src={imageSource}
        onClose={() => setShowImagePopupModal(false)}
        message={""}
      />
      <ContactAddressMapModal
        isOpen={showLocationModal}
        onClose={() => setShowLocationModal(false)}
        onLocationSelect={handleLocationSelect}
        initialLocation={
          customerLocation.latitude !== null && customerLocation.longitude !== null
            ? {
              latitude: customerLocation.latitude as number,
              longitude: customerLocation.longitude as number,
            }
            : { latitude: 25.1972, longitude: 55.2744 }
        }
        initialAddress={address}
        title="Select Contact Address"
      />
    </div>
  );
};

export default ManageMyProfile;
